import { booleanPointInPolygon, point as turfPoint } from '@turf/turf';
import { t } from 'i18next';
import { DEPLOYMENT_STATUS, DEVICE_LOCK_SETTINGS, LOCKER_STATUS } from 'vio-constants';
import { MAPBOX } from '../../constants/MAPBOX';
import { isOnline } from '../location/lib';
import { getLockStatus } from '../lockers/lib';
export function calculateAllCustomersInfo(allLockers, consumerAPI) {
    const allCustomersInfo = {};
    for (let i = 0; i < allLockers.length; i += 1) {
        const locker = allLockers[i];
        const { organization, status } = locker;
        let location;
        if (consumerAPI) {
            const { edge_location: edgeLocation } = locker;
            ({
                slug: location
            } = edgeLocation);
        }
        else {
            ({
                location
            } = locker);
        }
        if (!Object.prototype.hasOwnProperty.call(allCustomersInfo, location)) {
            allCustomersInfo[location] = {};
        }
        const customersInfoByLocation = allCustomersInfo[location];
        if ((organization === null || organization === void 0 ? void 0 : organization.name) && status === LOCKER_STATUS.ASSIGNED) {
            let name;
            let slug;
            if (consumerAPI) {
                ({
                    name,
                    slug
                } = locker.organization);
            }
            else {
                ({
                    name,
                    slug
                } = locker.organization);
            }
            if (Object.prototype.hasOwnProperty.call(customersInfoByLocation, slug)) {
                customersInfoByLocation[slug] = {
                    lockers: [...customersInfoByLocation[slug].lockers, locker],
                    name
                };
            }
            else {
                customersInfoByLocation[slug] = {
                    lockers: [locker],
                    name
                };
            }
        }
    }
    return allCustomersInfo;
}
export function calculateAvailableRacksByInventory(inventory) {
    const rackIds = Object.keys(inventory);
    return rackIds.map(rackId => {
        const rack = rackId.split('-')[1];
        return Number(rack);
    });
}
export function calculateCustomersInfo(lockers, consumerAPI) {
    const customersInfo = {};
    for (let i = 0; i < lockers.length; i += 1) {
        const locker = lockers[i];
        const { organization, status } = locker;
        if ((organization === null || organization === void 0 ? void 0 : organization.name) && status === LOCKER_STATUS.ASSIGNED) {
            let name;
            let slug;
            if (consumerAPI) {
                ({
                    name,
                    slug
                } = locker.organization);
            }
            else {
                ({
                    name,
                    slug
                } = locker.organization);
            }
            if (Object.prototype.hasOwnProperty.call(customersInfo, slug)) {
                customersInfo[slug] = {
                    lockers: [...customersInfo[slug].lockers, locker],
                    name
                };
            }
            else {
                customersInfo[slug] = {
                    lockers: [locker],
                    name
                };
            }
        }
    }
    return customersInfo;
}
export function calculateCustomersInfoByLocations(locations, customersInfo) {
    const customers = {};
    for (let i = 0; i < locations.length; i += 1) {
        const location = locations[i];
        const customersList = customersInfo[location];
        if (!customersList) {
            continue;
        }
        const customersListKeys = Object.keys(customersList);
        for (let j = 0; j < customersListKeys.length; j += 1) {
            const customer = customersListKeys[j];
            const { lockers, name } = customersList[customer];
            if (Object.prototype.hasOwnProperty.call(customers, customer)) {
                customers[customer] = {
                    lockers: [...customers[customer].lockers, ...lockers],
                    name
                };
            }
            else {
                customers[customer] = customersList[customer];
            }
        }
    }
    return customers;
}
export function calculateDisplayedLocations(locations, northEastBound, southWestBound, polygons, consumerAPI) {
    const displayedLocations = [];
    for (let i = 0; i < locations.length; i += 1) {
        const currentLocation = locations[i];
        const { latitude, longitude, slug } = currentLocation;
        let deploymentStatus;
        if (consumerAPI) {
            ({
                build_state: deploymentStatus
            } = currentLocation);
        }
        else {
            ({
                deployment_status: deploymentStatus
            } = currentLocation);
        }
        if (!isOnline(deploymentStatus)) {
            continue;
        }
        if (polygons && polygons.length > 0) {
            if (polygons.some(polygon => booleanPointInPolygon(turfPoint([longitude, latitude]), polygon))) {
                displayedLocations.push(slug);
            }
            continue;
        }
        if (latitude <= northEastBound.lat && latitude >= southWestBound.lat && longitude <= northEastBound.lng && longitude >= southWestBound.lng) {
            displayedLocations.push(slug);
        }
    }
    return displayedLocations;
}
export function calculateDisplayedPower(power) {
    if (!power) {
        return t('NA', {
            ns: 'Common'
        });
    }
    if (power < 1000) {
        return `${power} kW`;
    }
    return `${(power / 1000).toFixed(2)} MW`;
}
export function calculateExhaustTemperature(temperatureCount, temperatureSum) {
    return temperatureCount > 0 ? temperatureSum / temperatureCount : 0;
}
export function calculateFacilityDetailsByLocation(location, consumerAPI) {
    const { estimated_deployment } = location;
    let availableLockers;
    let availablePower;
    let deploymentStatus;
    let totalLockers;
    let totalPower;
    if (consumerAPI) {
        const { build_state, capacity } = location;
        const { available, total } = capacity;
        ({
            lockers: availableLockers,
            power: availablePower
        } = available);
        ({
            lockers: totalLockers,
            power: totalPower
        } = total);
        deploymentStatus = build_state;
    }
    else {
        ({
            available_it_power: availablePower,
            deployment_status: deploymentStatus,
            lockers_available: availableLockers,
            lockers_total: totalLockers,
            total_it_power: totalPower
        } = location);
    }
    if (deploymentStatus === DEPLOYMENT_STATUS.ONLINE) {
        return [{
                name: t('TOTAL_POWER', {
                    ns: 'Common'
                }),
                value: calculateDisplayedPower(totalPower)
            }, {
                name: t('AVAILABLE_POWER', {
                    ns: 'Common'
                }),
                value: calculateDisplayedPower(availablePower)
            }, {
                name: t('TOTAL_POWER_ZONES', {
                    ns: 'Common'
                }),
                value: totalLockers
            }, {
                name: t('AVAILABLE_POWER_ZONES', {
                    ns: 'Common'
                }),
                value: availableLockers
            }];
    }
    return [{
            name: t('DEPLOYMENT_STATUS', {
                ns: 'Common'
            }),
            value: deploymentStatus
        }, {
            name: t('ESTIMATED_DEPLOYMENT', {
                ns: 'Common'
            }),
            value: estimated_deployment || t('TBD', {
                ns: 'Common'
            })
        }, {
            name: t('TOTAL_POWER', {
                ns: 'Common'
            }),
            value: totalPower ? calculateDisplayedPower(totalPower) : t('TBD', {
                ns: 'Common'
            })
        }, {
            name: t('AVAILABLE_POWER', {
                ns: 'Common'
            }),
            value: availablePower ? calculateDisplayedPower(availablePower) : t('NA', {
                ns: 'Common'
            })
        }, {
            name: t('TOTAL_POWER_ZONES', {
                ns: 'Common'
            }),
            value: totalLockers || t('TBD', {
                ns: 'Common'
            })
        }, {
            name: t('AVAILABLE_POWER_ZONES', {
                ns: 'Common'
            }),
            value: availableLockers || t('NA', {
                ns: 'Common'
            })
        }];
}
export function calculateFacilityDetailsByLocations(locations, allLocations, consumerAPI) {
    let totalPower = 0;
    let availablePower = 0;
    let totalPowerZones = 0;
    let availablePowerZones = 0;
    for (let i = 0; i < locations.length; i += 1) {
        const locationSlug = locations[i];
        const location = getLocationBySlug(locationSlug, allLocations);
        let availableSiteLockers;
        let availableSitePower;
        let totalSiteLockers;
        let totalSitePower;
        if (consumerAPI) {
            const { capacity } = location;
            const { available, total } = capacity;
            ({
                lockers: availableSiteLockers,
                power: availableSitePower
            } = available);
            ({
                lockers: totalSiteLockers,
                power: totalSitePower
            } = total);
        }
        else {
            ({
                available_it_power: availableSitePower,
                lockers_available: availableSiteLockers,
                lockers_total: totalSiteLockers,
                total_it_power: totalSitePower
            } = location);
        }
        totalPower += totalSitePower;
        availablePower += availableSitePower;
        totalPowerZones += totalSiteLockers;
        availablePowerZones += availableSiteLockers;
    }
    return [{
            name: t('TOTAL_POWER', {
                ns: 'Common'
            }),
            value: calculateDisplayedPower(totalPower)
        }, {
            name: t('AVAILABLE_POWER', {
                ns: 'Common'
            }),
            value: calculateDisplayedPower(availablePower)
        }, {
            name: t('TOTAL_POWER_ZONES', {
                ns: 'Common'
            }),
            value: totalPowerZones
        }, {
            name: t('AVAILABLE_POWER_ZONES', {
                ns: 'Common'
            }),
            value: availablePowerZones
        }];
}
export function calculateGeoLocation(location) {
    const { coords } = location;
    const { latitude, longitude } = coords;
    const geoLocation = [longitude, latitude];
    return geoLocation;
}
export function calculateInventory(lockers) {
    const inventory = {};
    for (let i = 0; i < lockers.length; i += 1) {
        const { organization, sku, status, tenantable } = lockers[i];
        const [position, rack, chamber, siteId] = sku.split('.');
        const rackId = `rack-${rack.charAt(1)}`;
        const lockerId = `locker-${position}`;
        const name = organization === null || organization === void 0 ? void 0 : organization.name;
        if (!Object.prototype.hasOwnProperty.call(inventory, rackId)) {
            inventory[rackId] = {};
        }
        inventory[rackId][lockerId] = {
            location: `${chamber}.${siteId}`,
            name,
            status,
            tenantable
        };
    }
    return inventory;
}
export function calculateLocations(locations, customersInfo, consumerAPI) {
    return locations.map(location => {
        const { city, deployed_hardware, name, site_id, slug, state } = location;
        const customersInfoByLocation = customersInfo && customersInfo[slug];
        const customersLength = customersInfoByLocation ? Object.keys(customersInfoByLocation).length : 0;
        let availableSitePower;
        let availableSiteLockers;
        let siteDeploymentStatus;
        let siteStatus;
        if (consumerAPI) {
            const { build_state, capacity, operational_status } = location;
            const { available } = capacity;
            ({
                lockers: availableSiteLockers,
                power: availableSitePower
            } = available);
            siteDeploymentStatus = build_state;
            siteStatus = operational_status;
        }
        else {
            ({
                available_it_power: availableSitePower,
                deployment_status: siteDeploymentStatus,
                lockers_available: availableSiteLockers,
                status: siteStatus
            } = location);
        }
        const calculatedLocation = {
            availableLockers: availableSiteLockers,
            availablePower: calculateDisplayedPower(availableSitePower),
            city,
            customers: customersLength,
            deployed_hardware,
            deployment_status: siteDeploymentStatus,
            name,
            site_id,
            slug,
            state,
            status: siteStatus
        };
        return calculatedLocation;
    });
}
export function getCoordinatesBySlug(destSlug, locations) {
    let i;
    const coordinates = [];
    for (i = 0; i < locations.length; i += 1) {
        const location = locations[i];
        const { slug } = location;
        if (destSlug === slug) {
            const { latitude, longitude } = location;
            coordinates.push(longitude, latitude);
            break;
        }
    }
    if (coordinates.length > 0) {
        return coordinates;
    }
    return undefined;
}
export function getLocationBySiteId(siteId, locations) {
    let locationBySiteId;
    for (let i = 0; i < locations.length; i += 1) {
        const location = locations[i];
        if (location.site_id.toLowerCase() === siteId.toLowerCase()) {
            locationBySiteId = location;
            break;
        }
    }
    return locationBySiteId;
}
export function getLocationBySlug(slug, locations) {
    let locationBySlug;
    for (let i = 0; i < locations.length; i += 1) {
        const location = locations[i];
        if (location.slug === slug) {
            locationBySlug = location;
            break;
        }
    }
    return locationBySlug;
}
export function getLocationName(slug, locations) {
    let locationName;
    for (let i = 0; i < locations.length; i += 1) {
        const location = locations[i];
        if (location.slug === slug) {
            locationName = location.name;
            break;
        }
    }
    return locationName;
}
export function getLockAction(lockStatus) {
    const { LOCK, UNLOCK } = DEVICE_LOCK_SETTINGS;
    const status = getLockStatus(lockStatus);
    return status === t('LOCKED', {
        ns: 'Common'
    }) ? UNLOCK : LOCK;
}
export function getOfflineIXOverlays(ixOverlays, consumerAPI) {
    return ixOverlays.filter(ixOverlay => {
        let ixDeploymentStatus;
        if (consumerAPI) {
            ({
                status: ixDeploymentStatus
            } = ixOverlay);
        }
        else {
            ({
                deployment_status: ixDeploymentStatus
            } = ixOverlay);
        }
        return ixDeploymentStatus !== DEPLOYMENT_STATUS.ONLINE;
    });
}
export function getOfflineLocations(locations, consumerAPI) {
    return locations.filter(location => {
        let siteDeploymentStatus;
        if (consumerAPI) {
            ({
                build_state: siteDeploymentStatus
            } = location);
        }
        else {
            ({
                deployment_status: siteDeploymentStatus
            } = location);
        }
        return siteDeploymentStatus !== DEPLOYMENT_STATUS.ONLINE;
    });
}
export function getOnlineIXOverlays(ixOverlays, consumerAPI) {
    return ixOverlays.filter(ixOverlay => {
        let ixDeploymentStatus;
        if (consumerAPI) {
            ({
                status: ixDeploymentStatus
            } = ixOverlay);
        }
        else {
            ({
                deployment_status: ixDeploymentStatus
            } = ixOverlay);
        }
        return ixDeploymentStatus === DEPLOYMENT_STATUS.ONLINE;
    });
}
export function getOnlineLocations(locations, consumerAPI) {
    return locations.filter(location => {
        let siteDeploymentStatus;
        if (consumerAPI) {
            ({
                build_state: siteDeploymentStatus
            } = location);
        }
        else {
            ({
                deployment_status: siteDeploymentStatus
            } = location);
        }
        return siteDeploymentStatus === DEPLOYMENT_STATUS.ONLINE;
    });
}
export function getLocationsForMarket(market, locations, consumerAPI) {
    return locations.filter(location => {
        let edgeMarket;
        if (consumerAPI) {
            const { market } = location;
            ({
                name: edgeMarket
            } = market);
        }
        else {
            ({
                edge_market: edgeMarket
            } = location);
        }
        return edgeMarket === market;
    });
}
export function getStyleURLFromStyleName(style) {
    const { DARK, LIGHT, SATELLITE } = MAPBOX.STYLES;
    switch (style) {
        case LIGHT.NAME:
            return LIGHT.URL;
        case SATELLITE.NAME:
            return SATELLITE.URL;
        case DARK.NAME:
            return DARK.URL;
        default:
            return DARK.URL;
    }
}
export function getStyleNameFromStyleURL(style) {
    const { DARK, LIGHT, SATELLITE } = MAPBOX.STYLES;
    switch (style) {
        case LIGHT.URL:
            return LIGHT.NAME;
        case SATELLITE.URL:
            return SATELLITE.NAME;
        case DARK.URL:
            return DARK.NAME;
        default:
            return DARK.NAME;
    }
}
export function getAccessToken() {
    if (window.atob && vaporio && vaporio.mapbox_api_token) {
        return window.atob(vaporio.mapbox_api_token);
    }
    return '';
}
